import { cleanEmpty } from 'utils/cleanEmpty';
import { formatInputToTimestamp } from 'utils/date';
import { mapToIds } from 'utils/id/mapToIds';

import { OrderAdjustmentsReportListFilterFormValues } from '../OrderAdjustmentsReportListFilter/OrderAdjustmentsReportListFilter';

export function mapFormValuesToUrlFilters(
  formValues: Partial<OrderAdjustmentsReportListFilterFormValues>,
) {
  const {
    appliedDate = [null, null],
    adjustmentType,
    adjustmentStatus,
    user,
    ...rest
  } = formValues;

  return cleanEmpty({
    ...rest,
    adjustmentType: mapToIds(adjustmentType),
    adjustmentStatus: mapToIds(adjustmentStatus),
    user: mapToIds(user),
    'createdAt[gte]': formatInputToTimestamp(appliedDate?.[0], { unit: 'seconds' }),
    'createdAt[lte]': formatInputToTimestamp(appliedDate?.[1], { unit: 'seconds' }),
  });
}
